import React from 'react'
import styled from 'styled-components';
import { ReactComponent as CloseIcon } from "../../Assets/iconsv2/generic/closeBtn.svg";
import { useTranslate } from '@tolgee/react';
const ChatDetailsHeader = ({ selectedConversation, handleClose }) => {
    const { t } = useTranslate();
    return (
        <Container>
            <Text>
                <h1>{t('general.details')}</h1>
            </Text>
            <CloseBtn onClick={handleClose}>
                <CloseIcon />
            </CloseBtn>
        </Container>
    )
}

export default ChatDetailsHeader
const Container = styled.div`
display:flex;
justify-content:space-between;
padding: 19px 16px;
align-items:center;
background:${({ theme }) => theme.menu.background};
border-bottom:1px solid ${({ theme }) => theme.sidebar.borderColor};
gap:20px;
`

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: px;
overflow:hidden;
h1{
  text-transform:capitalize;
color:${({ theme }) => theme.menu.primaryTextColor};
font-weight: 700;
font-size: 20px;
line-height: 32px;
letter-spacing: 0.04px;
vertical-align: middle;

}
`;

const CloseBtn = styled.button`
display:flex;
align-items:center;
justify-content:center;
border:none;
background:none;
cursor:pointer;
margin-left:auto;

svg{
height:26px;
width:26px;
color:${({ theme }) => theme.menu.selectedOpionBackground};
stroke:${({ theme }) => theme.sidebar.borderColor};
}
`